import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import {NotificationManager} from 'react-notifications';
import {useLayer} from 'react-laag';

import styled from 'styled-components';
import moment from 'moment';

import {deleteExtraWorkEntry} from './endpoints';
import errorHandler from '../../../util/errorHandler';

import Table from '../../../shared/elements/table/TableFeature';
import {Btn} from '../../../shared/elements/btn/Btn';
import IconContainer, {Icon} from '../../../shared/elements/icon/Icon';
import ConfirmTool from '../../../shared/elements/btn/ConfirmTool';

const ExtraWorkEntry = ({exw, reloadMonth, t, ewiBeingEdited, onStartEdit, customer}) => {
    let [deleteClicked, setDeleteClicked] = useState(false);

    const handleDelete = () => {
        deleteExtraWorkEntry(exw)
            .then(() => {
                NotificationManager.success(t('general.ChangesSaved'));
                reloadMonth();
            })
            .catch((e) => {
                NotificationManager.error(t('general.ChangesNotSaved'));
                errorHandler(e.response.data, true, t);
            })
            .finally(() => {
                setDeleteClicked(false);
            });
    };

    const {triggerProps, layerProps, renderLayer} = useLayer({
        isOpen: deleteClicked,
        placement: 'bottom-end',
        overflowContainer: false,
        auto: true,
        onOutsideClick: () => setDeleteClicked(false),
        triggerOffset: 8,
    });

    let ewDescription = _.find(customer.extraWorkItems, (ewi) => ewi.id === exw.extraWorkItemId).description;

    return (
        <CustomTableRow isBeingEdited={exw.id === ewiBeingEdited}>
            <Table.Data>{moment(exw.timestamp).format('DD-MM-YYYY')}</Table.Data>
            <Table.Data>{ewDescription}</Table.Data>
            <Table.Data>{exw.quantity}</Table.Data>
            <Table.Data>{exw.unit}</Table.Data>
            <Table.Data>
                {exw.pricePerUnit.toLocaleString('nl-NL', {
                    style: 'currency',
                    currency: 'EUR',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}
            </Table.Data>
            <Table.Data>
                {exw.totalPrice.toLocaleString('nl-NL', {
                    style: 'currency',
                    currency: 'EUR',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}
            </Table.Data>
            <Table.Data>{exw.remark}</Table.Data>
            <Table.Data iconRow="true">
                <TableBtn link color="primary" onClick={() => onStartEdit(exw.id)}>
                    <Icon icon="edit" />
                </TableBtn>
            </Table.Data>
            <Table.Data iconRow="true">
                <TableBtn link color="primary" onClick={() => setDeleteClicked(!deleteClicked)} {...triggerProps}>
                    <Icon icon="delete" color="var(--danger)" />
                </TableBtn>
            </Table.Data>
            {deleteClicked &&
                renderLayer(<ConfirmTool onClick={handleDelete} setClicked={setDeleteClicked} t={t} {...layerProps} />)}
        </CustomTableRow>
    );
};

const CustomTableRow = styled(Table.Row)`
    ${({isBeingEdited}) => {
        if (isBeingEdited) {
            return `

           td {
             background-color: var(--primary)!important;
           }

         
            &:not(:hover) {
                td {
                      color: white;
                }
                ${IconContainer} svg {
                color: white;
                 }
            }


              &:hover {
            td {
                color: var(--primary);
            }    
           }


            `;
        } else {
            return null;
        }
    }}
`;

const TableBtn = styled(Btn)`
    ${IconContainer}
    svg {
        width: 16px !important;
        height: 16px !important;
    }
`;

export default withTranslation()(ExtraWorkEntry);
